export function formatDuration(milliseconds: number, compact = false): string {
  if (!Number.isFinite(milliseconds) || milliseconds <= 0) return compact ? "0:00" : "—";
  const totalSeconds = Math.round(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  }
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

export function formatCueTime(milliseconds: number): string {
  const totalSeconds = Math.max(0, milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return "尚未同步";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "尚未同步";
  return new Intl.DateTimeFormat("zh-CN", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  }).format(date);
}

export function statusLabel(status: string, stage?: string): string {
  if (status === "ready") return "可学习";
  if (status === "failed") return "需要处理";
  if (status === "canceled") return "已取消";
  if (status === "queued") return "排队中";
  const labels: Record<string, string> = {
    starting: "准备任务",
    downloading: "下载视频",
    validating: "校验媒体",
    extracting: "提取音轨",
    transcribing: "识别英语",
    translating: "翻译字幕",
    ready: "可学习"
  };
  return labels[stage || status] || "处理中";
}

export function findActiveCueIndex(
  cues: Array<{ startMs: number; endMs: number }>,
  currentMs: number
): number {
  let low = 0;
  let high = cues.length - 1;
  let result = -1;
  while (low <= high) {
    const middle = Math.floor((low + high) / 2);
    const cue = cues[middle];
    if (currentMs < cue.startMs) {
      high = middle - 1;
    } else if (currentMs >= cue.endMs) {
      low = middle + 1;
    } else {
      result = middle;
      break;
    }
  }
  return result;
}

